import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivityDTO } from './activity.model';
import { ActivityService } from '../../services/acitvity.service';
import { ActivityListComponent } from '../activity-list/activity-list.component';
import { Department } from '../user/department.model';
import { UserService } from '../../services/user.service';
import { RoleEnum } from '../../enums/role.enum';


@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.css',
  standalone: false
})
export class ActivityComponent implements OnInit {
  @ViewChild(ActivityListComponent) activityListCompo: any;

  displayedColumns: string[] = [
    'categoryName',
    'categoryType',
    'category'
  ];
  activityData: ActivityDTO[] = [];
  departments: Department[] = [];
  isSubmitting: boolean = false;
  submitSuccess: boolean = false;
  submitError: string = '';

  activityFormGroup: FormGroup;
  categoryJsonData: any;
  typeList: any;
  userData: any;
  isAdmin: boolean = false;
  isDepartmentAdmin: boolean = false;

  constructor(
    private activityService: ActivityService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private userService: UserService
  ) {
    this.activityFormGroup = this.fb.group({
      name: ['', Validators.required],
      categoryTypeId: ['', Validators.required],
      departmentId: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.getActivityCategoryType();
    this.getStorageData();
    this.getDepartments();
    this.setDeptValueForDeptAdmin();
  }

  getStorageData() {
    let user: any = sessionStorage.getItem("userData")
    this.userData = JSON.parse(user)
    this.isAdmin = this.userData.roleId == RoleEnum.ADMIN;
    this.isDepartmentAdmin = this.userData.roleId == RoleEnum.DEPARTMENT_ADMIN;
  }


  getActivityCategoryType() {
    this.activityService.getActivityCategoryType().subscribe(
      (res: any) => {
        if (res && res.responseObject) {
          if (Array.isArray(res.responseObject)) {
            this.typeList = res.responseObject.map((type: any) => ({
              ...type,
            }));
          }
        } else {
          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  onSaveCategory() {
    if (this.activityFormGroup.valid) {
      // const formValue = this.activityFormGroup.value;
      const formValue = this.activityFormGroup.getRawValue();
      const activityData = {
        ...formValue
      };

      this.activityService.create(activityData).subscribe(
        (res: any) => {
          this.isSubmitting = false;
          this.submitSuccess = true;
          this.activityData.push(res.responseObject); // Add new user data to the array
          this.activityListCompo.getAllActivity(1, 10); // Refresh the table
          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });

          // Reset form and clear error states
          this.activityFormGroup.reset();
          Object.keys(this.activityFormGroup.controls).forEach(key => {
            this.activityFormGroup.get(key)?.setErrors(null);
          });

          // Mark form as pristine and untouched
          this.activityFormGroup.markAsPristine();
          this.activityFormGroup.markAsUntouched();
          this.setDeptValueForDeptAdmin();
          this.activityListCompo.AllActivities();
        },
        (error: any) => {
          this.isSubmitting = false;
          this.submitSuccess = false;
          this.submitError = 'Error submitting form';
          this.snackBar.open(error.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      );
    } else {
      this.submitSuccess = false;
      this.submitError = 'Form is invalid. Please check all fields.';
      this.snackBar.open('Form is invalid. Please check all fields.', 'Close', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      });

      // Mark all fields as touched to show errors
      this.activityFormGroup.markAllAsTouched();
    }
  };

  getDepartments(): void {
    this.userService.getDepartments().subscribe(
      (responseObject: Department[]) => {
        this.departments = responseObject.map((department: Department) => ({ id: department.id, departmentName: department.departmentName }));
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  setDeptValueForDeptAdmin(): void {
    if(this.isDepartmentAdmin) {
      this.activityFormGroup.patchValue({departmentId: this.userData.departmentId});
      this.activityFormGroup.get('departmentId')?.disable();
    }
  }
}
